<drawer
  [title]="'Add Bot'"
  [showHeaderButtons]="true"
  [hideDelete]="true"
  [hideCancel]="false"
  [hideSave]="false"
  [isClosed]="false"
  (saveEvent)="saveBot()"
  (cancelEvent)="cancel()"
  (closeEvent)="cancel()">
    <div class="drawer-content drawer-direct-content">
        <role-bot-manage [serviceId]="serviceId" [bot]="bot" [showBotAdd]="showBotAdd" (modalAddedEvent)="added()"></role-bot-manage>
    </div>
</drawer>